module.exports = __webpack_public_path__ + "img/img6.010b40d4.svg";